import { createSelector } from 'reselect'
import {
    areFiltersApplied,
    isZoomActive,
} from '../appliedFilters/selectors'
import {
    hasCollaborativeIndexationCampaign,
    isCollaborativeIndexationCreationOpened,
    isCollaborativeIndexationSummaryOpened,
    isCurrentMediaCollaborativeAnnotationLimitReached,
} from '../collaborativeIndexations/selectors'
import {
    IMAGE_SETTING_ASIDE_NAME,
    ZOOM_ASIDE_NAME,
} from './actions'
import { isThumbnailsNavigationOpened } from '../thumbnails/selectors'
import { isTableOfContentsOpened } from '../tableOfContents/selectors'
import { isPrintPreviewOpened } from '../print/selectors'
import {
    isCollaborativeIndexationEnabled,
    isUserLoggedIn
} from '../app/selectors'
import { isCurrentMediaTypeImage } from '../currentMedia/selectors'
import { isSocialSharingOpened } from '../share/selectors'
import {isResponsiveModeEnabled} from "../visualizer/selectors";

export const getAside = (state) => state.aside

export const getBottomToolbarActiveAside = createSelector(
    getAside,
    aside => aside.bottomToolbar.activeAside
)

export const isThumbnailsAsideDisplayed = createSelector(
    isThumbnailsNavigationOpened,
    isThumbnailsNavigationOpened => isThumbnailsNavigationOpened === true
)

export const isTableOfContentsAsideDisplayed = createSelector(
    isTableOfContentsOpened,
    isTableOfContentsOpened => isTableOfContentsOpened === true
)

export const isPrintPreviewAsideDisplayed = createSelector(
    isPrintPreviewOpened,
    isPrintPreviewOpened => isPrintPreviewOpened === true
)

export const isImageSettingAsideDisplayed = createSelector(
    getBottomToolbarActiveAside,
    activeAside => activeAside === IMAGE_SETTING_ASIDE_NAME
)

export const areImageSettingsDisplayed = createSelector(
    isImageSettingAsideDisplayed,
    areFiltersApplied,
    (isImageSettingAsideDisplayed, areFiltersApplied) => isImageSettingAsideDisplayed || areFiltersApplied
)

export const isZoomAsideDisplayed = createSelector(
    getBottomToolbarActiveAside,
    activeAside => activeAside === ZOOM_ASIDE_NAME
)

export const isZoomDisplayed = createSelector(
    isZoomAsideDisplayed,
    isZoomActive,
    (isZoomAsideDisplayed, isZoomActive) => isZoomAsideDisplayed || isZoomActive
)

export const isCollaborativeIndexationAsideDisplayed = createSelector(
    isCollaborativeIndexationSummaryOpened,
    isCollaborativeIndexationSummaryOpened => isCollaborativeIndexationSummaryOpened === true
)

export const isCollaborativeIndexationCreationAsideSelected = createSelector(
    isCollaborativeIndexationCreationOpened,
    isCollaborativeIndexationCreationOpened => isCollaborativeIndexationCreationOpened === true
)

export const isCollaborativeIndexationCreationAsideDisabled = createSelector(
    isUserLoggedIn,
    isCurrentMediaTypeImage,
    isCurrentMediaCollaborativeAnnotationLimitReached,
    (isUserLoggedIn, isCurrentMediaTypeImage, isCollaborativeAnnotationLimitReached) => ! isUserLoggedIn || ! isCurrentMediaTypeImage || isCollaborativeAnnotationLimitReached
)

export const isCollaborativeIndexationCreationAsideDisplayed = createSelector(
    isCollaborativeIndexationEnabled,
    hasCollaborativeIndexationCampaign,
    (isFeatureEnabled, hasActiveCampaign) => isFeatureEnabled && hasActiveCampaign
)

export const isCollaborativeIndexationAsideDisabled = createSelector(
    isCurrentMediaTypeImage,
    isCurrentMediaTypeImage => ! isCurrentMediaTypeImage
)

export const isSocialSharingAsideDisplayed = createSelector(
    isSocialSharingOpened,
    isSocialSharingOpened => isSocialSharingOpened
)

export const isBottomBarSocialSharingAsideDisplayed = createSelector(
    isSocialSharingOpened,
    isResponsiveModeEnabled,
    (isSocialSharingOpened, isResponsiveModeEnabled) => isSocialSharingOpened && isResponsiveModeEnabled
)

export const isItemLocked = createSelector(
    (state, toolbarName, item) => {
        return isToolbarLocked(state, toolbarName)
            && ! isToolbarLockedBy(state, toolbarName, item)
            && item.hasAside === true
    },
    isItemLocked => isItemLocked,
)

export const getToolbar = createSelector(
    getAside,
    (state, toolbarName) => toolbarName,
    (aside, toolbarName) => aside[`${toolbarName}Toolbar`] || null,
)

export const getToolbarLockedBy = createSelector(
    getAside,
    (state, toolbarName) => getToolbar(state, toolbarName),
    (aside, toolbar) => toolbar && toolbar.lockedBy
)

export const isToolbarLockedBy = createSelector(
    getToolbarLockedBy,
    (state, toolbar, item) => item,
    (lockedBy, item) => lockedBy === item.name
)

export const isToolbarLocked = createSelector(
    (state, toolbarName) => getToolbarLockedBy(state, toolbarName),
    lockedBy => !! lockedBy
)

export const getCollaborativeIndexationCreationTitle = createSelector(
    isCollaborativeIndexationCreationAsideDisabled,
    isUserLoggedIn,
    isCurrentMediaTypeImage,
    isCurrentMediaCollaborativeAnnotationLimitReached,
    (isAsideDisabled, isUserLoggedIn, isCurrentMediaTypeImage, isCollaborativeAnnotationLimitReached) => {

        let asideStatus = 'enabled'
        if(isAsideDisabled)
        {
            asideStatus = 'disabled'

            if(! isUserLoggedIn)
            {
                asideStatus = 'userIsNotLoggedIn'
            }

            if(! isCurrentMediaTypeImage)
            {
                asideStatus = 'mediaIsNotImage'
            }

            if(isCollaborativeAnnotationLimitReached)
            {
                asideStatus = 'collaborativeAnnotationLimitReached'
            }
        }

        return `visualizer:toolbar.left.collaborativeIndexationCreation.button.${asideStatus}`
    }
)
